
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/sesongavslutning-for-skianlegg",
      function () {
        return require("private-next-pages/[region]/sesongavslutning-for-skianlegg.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/sesongavslutning-for-skianlegg"])
      });
    }
  